/** An enum containing the list of feature types used on the maps. */
export enum FeatureTypes {
    AreaCenter = 'areaCenter',
    AreaLaneCenter = 'areaLaneCenter',
    AreaLaneLine = 'areaLaneLine',
    AreaPolygon = 'areaPolygon',
    LaneCenter = 'laneCenter',
    LaneLine = 'laneLine',
    ShipperLaneCenter = 'shipperLaneCenter',
    ShipperLaneLine = 'shipperLaneLine',
    OrderOriginCenter = 'orderOriginCenter',
    NetworkRecommendationLaneCenter = 'networkRecommendationLaneCenter',
    NetworkRecommendationLaneLine = 'networkRecommendationLaneLine',
    SelectedRecommendationLaneCenter = 'selectedRecommendationLaneCenter',
    SelectedRecommendationLaneLine = 'selectedRecommendationLaneLine',
}

/** An enum containing the list of additional map layers used. */
export enum MapLayers {
    balanceAreasCenterLayer = 'balance-areas-center-layer',
    densityAreasCenterLayer = 'density-areas-center-layer',
    densityAreasHeatmapLayer = 'density-areas-heatmap-layer',

    emptyMilesAreasCenterLayer = 'emptyMiles-areas-center-layer',
    emptyMilesAreasLaneCenterLayer = 'emptyMiles-areas-lane-center-layer',
    emptyMilesAreasLaneLineLayer = 'emptyMiles-areas-lane-line-layer',

    shipperHealthLaneCenterLayer = 'shipperHealth-lane-center-layer',
    shipperHealthLaneLineLayer = 'shipperHealth-lane-line-layer',

    laneCenterLayer = 'lane-center-layer',
    laneLineLayer = 'lane-line-layer',
    laneLineHoverLayer = 'lane-line-hover-layer',

    areaPolygonFillLayer = 'area-polygon-fill-layer',
    areaPolygonLineLayer = 'area-polygon-line-layer',

    shipperDetailsCenterLayer = 'shipperDetails-center-layer',
    shipperDetailsClusterLayer = 'shipperDetails-cluster-layer',
    shipperDetailsClusterLabelLayer = 'shipperDetails-clusterLabel-layer',

    networkRecommendationLaneCenterLayer = 'networkRecommendation-lane-center-layer',
    networkRecommendationLaneLineLayer = 'networkRecommendation-lane-line-layer',
    networkRecommendationLaneLineHoverLayer = 'networkRecommendation-lane-line-hover-layer',

    selectedRecommendationLaneCenterLayer = 'selectedRecommendation-lane-center-layer',
    selectedRecommendationLaneLineLayer = 'selectedRecommendation-lane-line-layer',
    selectedRecommendationLaneLineHoverLayer = 'selectedRecommendation-lane-line-hover-layer',
}

/** An enum containing the list of additional map sources used. */
export enum MapSources {
    areasSource = 'areas-source',
    balanceAreasSource = 'balance-areas-source',
    densityAreasSource = 'density-areas-source',
    emptyMilesAreasSource = 'emptyMiles-areas-source',
    laneDetailsSource = 'lanesDetails-source',
    lanesSource = 'lanes-source',
    networkRecommendationsSource = 'networkRecommendations-source',
    shipperDetailsSource = 'shipperDetails-source',
    shipperHealthLanesSource = 'shipperHealth-lanes-source',
}
